export default __webpack_public_path__ + "static/media/house-cook.025452e0.svg";